export default {
    apiUrl: process.env.NODE_ENV === 'development' ? 'http://localhost:1444/api/v1' : 'https://jardinfo.fr/api/v1',
    wsUrl: process.env.NODE_ENV === 'development' ? 'ws://localhost:3030' : 'wss://jardinfo.fr/websocket',
};